import React, { useState } from 'react'
import { getActualShopifyId } from './useShopifyFunctions'
const { config } = require('../config')

const useRebuy = () => {
  const [rebuyAddedToCart, setRebuyAddedToCart] = useState(false)
  const fetchRebuyData = async (productIds, limit) => {
    const REBUY_API_KEY = config.GATSBY_REBUY_API_KEY

    let shopifyIds = []

    productIds.map(id => shopifyIds.push(getActualShopifyId(id, 'Product')))

    const endPoint = `https://rebuyengine.com/api/v1/custom/id/2773?shopify_product_ids=${shopifyIds.join(
      ','
    )}&key=${REBUY_API_KEY}&limit=${limit}`

    return fetch(endPoint)
  }
  return { fetchRebuyData, rebuyAddedToCart, setRebuyAddedToCart }
}

export default useRebuy
